/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import isEmpty from 'lodash.isempty';
import {translate} from '@ion/core/src/locale/locale';
import {prerender} from './NotificationDetailsRenderer';

export interface NotificationDetailsProps {
  notification?: any;
}

/**
 * @function NotificationDetails
 *
 * The NotificationDetails component manages decoding and rendering a Notifications
 * Email and SMS Actions, which provide details related to the Alert such as the
 * rendered email template, recipients, the status of the message, etc..
 *
 * ```typescript
 *
 * import {NotificationDetails} from '@ion/dls/src/notifications'
 *
 * <NotificationDetails notification={notification} />
 *
 * ```
 */
export const NotificationDetails = ({notification}: NotificationDetailsProps) => {
  const {content, type} = prerender(notification);
  const hasContent = (type && content && !isEmpty(content) && content?.length > 1);
  return (
    <>
      {hasContent && content[1]}
      {(!type || !content || isEmpty(content)) && (
        <p>{translate('notifications:details.error')}</p>
      )}
    </>
  );
};

export default NotificationDetails;
